import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const retailerCollectionsV3AccessControl: DomainAccessControlConfig = {
  permissions: [
    Permission.RetailerCollectionsRetailerCollectionsV2,
    Permission.CatalogProductsView,
  ],
  restrictedBannersAllowed: true,
}

// Collection SFP layout builder — gated to R9 (r2026_09_0).
export const collectionPageBuilderAccessControl: DomainAccessControlConfig = {
  permissions: [
    Permission.RetailerCollectionsRetailerCollectionsV2,
    Permission.CatalogProductsView,
  ],
  minICPlatformVersion: ICPlatformVersion.r2026_09_0,
  restrictedBannersAllowed: true,
}
